import { render, staticRenderFns } from "./AppointmentSuccess.vue?vue&type=template&id=7631d68c&"
import script from "./AppointmentSuccess.vue?vue&type=script&lang=js&"
export * from "./AppointmentSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7631d68c')) {
      api.createRecord('7631d68c', component.options)
    } else {
      api.reload('7631d68c', component.options)
    }
    module.hot.accept("./AppointmentSuccess.vue?vue&type=template&id=7631d68c&", function () {
      api.rerender('7631d68c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/AppointmentPage/components/common/AppointmentSuccess.vue"
export default component.exports